import React from "react";
import { X } from "lucide-react";

interface ItemListPopupProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

const ItemListPopup: React.FC<ItemListPopupProps> = ({
  title,
  onClose,
  children,
  className = "",
}) => {
  return (
    <div
      className={`
        fixed top-0 right-0 z-50 h-screen bg-white
        shadow-[0px_6px_24px_0px_rgba(0,0,0,0.15)] pl-6 pr-3 pt-6 pb-6
        flex flex-col transition-all duration-300 ease-in-out
        rounded-tl-xl rounded-bl-xl overflow-hidden
        w-full sm:w-[50%] md:w-[40%] lg:w-[35%] xl:w-[25%] 2xl:w-[25%] 3xl:w-[23%]
        ${className}`}
    >
      <header className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold sm:text-sm md:text-lg">{title}</h2>
        <button
          onClick={onClose}
          aria-label="Close popup"
          className="transition-colors hover:text-red-500"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>
      </header>
      <main className="flex-1 text-sm sm:text-base overflow-y-auto">
        {children}
      </main>
    </div>
  );
};

export default ItemListPopup;
